<template>
  <v-select hide-details outlined dense @input="event => { emitChange(event) }" :items="items" v-model="selectedValue"
    :label="$t('message.paid_with')" item-text="name" item-value="value">
  </v-select>
</template>

<script>
export default {
  data() {
    return {
      selectedValue: null,
      items: [
        { name: this.$t('message.cash'), value: 'cash' },
        { name: this.$t('message.card'), value: "card" },
        { name: this.$t('message.debit'), value: "debit" },
        { name: this.$t('message.mobile'), value: "mobile" },
        { name: this.$t('message.transfer'), value: "transfer" }
      ]
    };
  },
  created() {
    this.selectedValue = this.value
  },
  props: {
    value: null
  },
  methods: {
    emitChange(event) {
      this.$emit("input", event);
    }
  }
};
</script>

<style scoped></style>